import Axios from 'axios';
import {urlAPIDirectus} from "../config/globals";

function findMatiereById(type,id){
    var collection='';
    if(type=='foret')  collection='foret_liste_essence';
    if(type=='culture')  collection='culture_liste_matiere';
    if(type=='geo')  collection='geologie_liste_materiau';

    if(type!='') {
        return Axios
            .get(urlAPIDirectus + collection +
                '/' + id + "?fields=*.*.*.*,fichiers.item:fichier.*,images.item:plan.*")
            .then(response => response.data.data);
    }
    return (null);
}

function findMatiereByName(type,search){
    var collection='';
    var filter='';
    if(type=='foret'){
        collection='foret_liste_essence';
        filter="[libelle][_istarts_with]="+search.trim();;
    }
    if(type=='culture'){
        collection='culture_liste_matiere';

        if(search.indexOf(';')){
            let searchs=search.split(';');
            filter+='{"_or": [';
            for(let a=0;a<searchs.length;a++){
                if(a!=0) filter+=',';
                filter+='{"libelle": {"_icontains": "'+searchs[a].trim()+'"}}';
            }
            filter+=']}';

            filter='='+filter;

        }else{
            filter="[libelle][_istarts_with]="+search.trim();
        }

    }
    if(type=='geo'){
        collection='geologie_liste_materiau';

        if(search.indexOf('-')){
            let searchs=search.split('-');
            filter+='{"_or": [';
            for(let a=0;a<searchs.length;a++){
                if(a!=0) filter+=',';
                filter+='{"libelle": {"_icontains": "'+searchs[a].trim()+'"}}';
            }
            filter+=']}';

            filter='='+filter;
        }else{
            filter="[libelle][_istarts_with]="+search.trim();
        }
    }

    if(type!='') {
        return Axios
            .get(urlAPIDirectus + collection + "?filter"+filter+"&fields=*.*,fichiers.item:fichier.*,images.item:image_liee.*")
            .then(response => response.data.data);
    }

    return (null);
}

export {
    findMatiereById,
    findMatiereByName
}